export default class ScrollTo {
    constructor() {
        this.scrollToToggles = document.querySelectorAll('[data-scroll-target]');
        if (this.scrollToToggles.length) {
            this.addEventListeners();
        }
    }
    addEventListeners() {
        this.scrollToToggles.forEach((toggle) => {
            toggle.addEventListener('click', (e) => {
                e.preventDefault();
                const target = toggle.getAttribute('data-scroll-target');
                const targetElement = document.querySelector(target || '');
                let headerOffset = 0;
                if (targetElement && toggle.hasAttribute('data-has-header-offset')) {
                    if (targetElement.getBoundingClientRect().top < toggle.getBoundingClientRect().top) {
                        headerOffset = this.getHeaderOffset();
                    }
                }
                this.scrollToElement(target, headerOffset);
            });
        });
    }
    getHeaderOffset() {
        const header = document.querySelector('body > header');
        if (header) {
            const height = getComputedStyle(header).height;
            return parseInt(height);
        }
        return 0;
    }
    scrollToElement(target, offset = 0) {
        const targetElement = document.querySelector(target || '');
        if (targetElement) {
            const top = targetElement.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({ top: top, behavior: 'smooth' });
        }
    }
}
